/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from '@shared/DbBaseObject.js';

export default class PersonItem extends DbBaseObject{


	name: string = ""
	email: string = ""


	constructor(id: string = null, name: string = null, email: string = null) {
		super();
		this.id = id;
		this.name = name;
		this.email = email;
	}
}



